import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import SideNavItem from './SideNavItem';
import DeprecatingTag from './DeprecatingTag';

const SideNavItemCollapsable = (props) => {
   const [isOpen, setIsOpen] = useState(props.isActive);

   // Used to close other modals that is a sibling of 'this' SideNavItemCollapsable
   // This is a fix to the flicker issue of the SideNav when changing page
   // Since current routing configuration unmounts and then remounts the SideNav component when switching route
   const [selfDelta, setSelfDelta] = useState();

   const ref = useRef({
      deltaEmitted: undefined,
   });


   useEffect(() => {
      setIsOpen(props.isActive);
   }, [props.isActive]);

   const handleOnClick = useCallback(() => {
      setIsOpen((prevIsOpen) => !prevIsOpen);

      if (!isOpen) {
         const deltaToEmit = new Date();
         props.setParentDelta(deltaToEmit);
         ref.current.deltaEmitted = deltaToEmit;
      }
   }, [isOpen, props.setParentDelta]);

   useEffect(() => {
      if (props.parentDelta && props.parentDelta !== ref.current.deltaEmitted) {
         setIsOpen(false);
      }
   }, [props.parentDelta]);

   return (
      <li className={`nav-collapsable ${ isOpen ? 'open' : '' }`}>
         <div
            role='button'
            data-toggle='collapse'
            aria-expanded={ isOpen }
            onClick={ handleOnClick }
            className={ `collapsable sidebar-link ${ !isOpen ? 'collapsed' : '' } ${ props.isActive ? 'active' : '' }` }
         >
            {
               props.icon
               && <props.icon size={ 18 } className='align-middle mr-2'/>
            }
            <span className='align-middle'>{ props.name }</span>
            {
               props.deprecating
               && <DeprecatingTag/>
            }
         </div>
         <Collapse isOpen={ isOpen }>
            <ul>
               {
                  props.subItems.map((subItem) => (
                     <SideNavItem
                        { ...subItem }
                        setParentDelta={ setSelfDelta }
                        parentDelta={ selfDelta }
                        key={ `${ subItem.name }-${ subItem.path }` }
                     />
                  ))
               }
            </ul>
         </Collapse>
      </li>
   );
};

SideNavItemCollapsable.propTypes = {
   name: PropTypes.string.isRequired,
   level: PropTypes.number.isRequired,
   subItems: PropTypes.arrayOf(PropTypes.shape({})),
   path: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.oneOf([null]).isRequired,
   ]),
   deprecating: PropTypes.bool,
};

SideNavItemCollapsable.defaultProps = {
   subItems: [],
   path: null,
   deprecating: false,
};


export default withRouter(SideNavItemCollapsable);
